import Header from "../components/header/header";
import Footer from "../components/footer";
import "../style/App.css";

export default function Autorpage() {
  return (
    <div>
      <Header></Header>
      <h1 className="page_content">AUTOR</h1>
      <Footer></Footer>
    </div>
  );
}
